import React, { useEffect, useState } from "react";
import "../sign-up/sign-up.css";
import "./signin.css";
import { Link, useNavigate } from "react-router-dom";
import { Login, GetCustomerAPIs } from "api-services";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../../../assets/images/vct_technologies_logo_dark-xl.png";
import LogoV from "../../../assets/images/vct-technologies-logo-v.png";
import { CircularProgress, Icon } from "@mui/material";
import { setObjectValue } from "commons/storage";
import { LOGIN_SUCCESS } from "redux/constants";
function Basic() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.authentication.loading);
  //const loading = true
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState("");
  const [passwordType, setPasswordType] = useState("password");

  //   Form validation
  const [errors, setErrors] = useState({});

  //   Setting button text
  const buttonText = "Sign In";

  const { token, tokenValidity } = useSelector((state) => state.authentication);

  useEffect(() => {
    if (token) {
      navigate("/dashboard");
    }
  }, []);

  // useEffect(() => {
  //   const keyDownHandler = event => {
  //     if (event.key === 'Enter') {
  //       event.preventDefault();
  //       handleSignIn();
  //     }
  //   };

  //   document.addEventListener('keydown', keyDownHandler);

  //   return () => {
  //     document.removeEventListener('keydown', keyDownHandler);
  //   };
  // }, []);

  const handleValidation = () => {
    let tempErrors = {};
    let isValid = true;

    if (username.length <= 0) {
      tempErrors["username"] = true;
      isValid = false;
    }
    if (password.length <= 0) {
      tempErrors["password"] = true;
      isValid = false;
    }

    setErrors({ ...tempErrors });
    return isValid;
  };

  const handleSignIn = (e) => {
    e.preventDefault();
    let data = {
      UserName: username,
      Password: password,
    };

    if (handleValidation()) {
      Login(
        dispatch,
        data,
        navigateToDashboard,
        setShowErrorMessage,
        clearFields
      );
    }
  };

  const togglePasswordType = () => {
    if (passwordType == "password") {
      setPasswordType("text");
    } else {
      setPasswordType("password");
    }
  };

  const navigateToDashboard = (userData) => {
    // if (userData?.customer?.roleId == 1) {
    //   filteredProducts = products.filter((prod) => userData.apirequestaccessItem.find((item) => item.apiid == prod.key && (item.techStatus == "A" || item.techStatus == "")));
    //   newProducts = products.filter((prod) => !filteredProducts.find((item) => item.key == prod.key));
    // }

    GetCustomerAPIs(
      dispatch,
      userData?.customer?.id,
      (res) => {
        userData.apirequestaccessItem = res.data;
        setObjectValue("user_data", userData);
        let data = {
          user_data: userData,
          token: token,
          token_validity: tokenValidity,
        };

        dispatch({ type: LOGIN_SUCCESS, payload: data });
      },
      () => {}
    );

    navigate("/dashboard");
  };
  const clearFields = () => {
    setUsername("");
    setPassword("");
  };

  return (
    <div>
      <div className="wrap-register sigin">
        <div className="container-fluid text-center">
          <div className="row">
            <div className="col-md-6 p-0">
              <div className="bg-common">
                <div className="text-start cred">
                  <Link to="/">
                    <img
                      src={Logo}
                      alt="VCT Technologies LLC"
                      className="cred-logo"
                    />
                  </Link>
                  <h1 className="cred-title ps-2">Welcome Back!</h1>
                </div>
              </div>
            </div>
            <div className="col-md-6 p-5 bg-trans">
              <div className="row justify-content-md-center">
                <div className="col-md-12 col-lg-6 p-lg-5">
                  <Link to="/">
                    <img src={LogoV} className="cred-logo" />
                  </Link>
                  <h3 className="cred-form-title text-start">Sign In</h3>
                  <p className="cred-form-desc text-start">
                    Need an account?
                    <Link to="/authentication/sign-up"> Sign Up</Link>
                  </p>
                  <form onSubmit={handleSignIn}>
                    <div className="col-12 mb-3">
                      <input
                        type="email"
                        className="form-control"
                        id="username"
                        placeholder="Email Address*"
                        value={username}
                        onChange={(e) => {
                          setUsername(e.target.value);
                        }}
                      />
                      {errors?.username && (
                        <p className="text-red">Email cannot be empty.</p>
                      )}
                    </div>
                    <div className="col-12">
                      {/* <input
                          type="password"
                          className="form-control"
                          id="password"
                          name="password"
                          placeholder="Password*"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                        /> */}

                      <div className="password-field">
                        <input
                          type={passwordType}
                          className="form-control"
                          id="password"
                          name="password"
                          placeholder="Password*"
                          value={password}
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                        />
                        <Icon
                          className="password-input-icon"
                          onClick={togglePasswordType}
                        >
                          {passwordType == "password"
                            ? "visibility"
                            : "visibility_off"}
                        </Icon>
                      </div>

                      {errors?.password && (
                        <p className="text-red">Password cannot be empty.</p>
                      )}
                    </div>
                    <p className="text-end forgot-pass">
                      <Link to="/authentication/forgot-password">
                        Forgot Password?
                      </Link>
                    </p>
                    <div className="d-grid gap-2 col-12 mx-auto mb-3">
                      {showErrorMessage != "" && (
                        <p className="text-error text-center">
                          {showErrorMessage}
                        </p>
                      )}
                      <button
                        className="btn cred-btn-contact justify-content-center"
                        onClick={handleSignIn}
                        disabled={loading}
                      >
                        {loading ? (
                          <CircularProgress
                            size={25}
                            color="white"
                            className="loaderbtn"
                          />
                        ) : (
                          buttonText
                        )}
                      </button>
                    </div>
                  </form>
                </div>
                <div className="footer row justify-content-md-center">
                  <div className="col-md-12 col-lg-9 bg-trans p-0">
                    <div className="wrap-footer-inners">
                      <hr />
                      <Link to="/privacypolicy" target="_blank">
                        Privacy Policy
                      </Link>
                      <Link to="/termsofuse" target="_blank">
                        Terms of Use
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Basic;
